import {createAction, props} from "@ngrx/store";
import {Project, VerifyDeleteProjectIsValidResponse} from "../../models/project.model";

export const loadProjects = createAction('[ProjectList Component] Load Projects');
export const loadProjectsSuccess = createAction(
  '[ProjectList Component] Projects Load Success',
  props<{ projects: Project[] }>()
);

export const loadProjectsFailure = createAction(
  '[ProjectList Component] Projects Load Failure',
  props<{ error: string }>()
);

export const verifyDeleteProjectIsValid = createAction(
  '[ProjectList Component] VerifyDeleteProjectIsValid',
  props<{ projectId: string }>()
);

export const verifyDeleteProjectIsValidSuccess = createAction(
  '[ProjectList Component] VerifyDeleteProjectIsValid Success',
  props<{ verifyDeleteIsValidResponse: VerifyDeleteProjectIsValidResponse }>()
);

export const verifyDeleteProjectIsValidFailure = createAction(
  '[ProjectList Component] VerifyDeleteProjectIsValid Failure',
  props<{ error: string }>()
);

export const removeProject = createAction(
  '[ProjectList Component] Remove Project',
  props<{ projectId: string }>()
);

export const removeProjectSuccess = createAction(
  '[ProjectList Component] Project Remove Success',
  props<{ projectId: string, successMessage: string }>()
);

export const removeProjectFailure = createAction(
  '[ProjectList Component] Project Remove Failure',
  props<{ error: string }>()
);

export const modifyProject = createAction(
  '[ProjectList Component] Modify Project',
  props<{ project: Project }>()
);

export const modifyProjectSuccess = createAction(
  '[ProjectList Component] Project Modify Success', props<{ successMessage: string }>()
);

export const modifyProjectFailure = createAction(
  '[ProjectList Component] Project Modify Failure',
  props<{ error: string }>()
);

export const addProject = createAction(
  '[ProjectList Component] Add Project',
  props<{ project: Project }>()
);
export const addProjectSuccess = createAction(
  '[ProjectList Component] Project Add Success',
  props<{ project: Project, successMessage: string }>()
);

export const addProjectFailure = createAction(
  '[ProjectList Component] Project Add Failure',
  props<{ error: string }>()
);
